module.exports = __webpack_public_path__ + "img/avatar1.86d70638.png";